import { ReduxState } from '../reducers/global';

export const selectCurrentUser = (
	state: ReduxState
): {
	hasuraKey: string;
	tipoUsuario: 'admin' | 'profesor' | 'estudiante' | 'monitor' | 'colegio';
	uid: string;
	user_id: string;
} => {
	return state.auth || {};
};

export const selectAuthorizedAuthState = (state: ReduxState) => {
	return state.auth.authorized;
};

export type userTypeTypes = 'admin' | 'profesor' | 'student' | 'colegio' | 'monitor' | 'noUser';

export const selectUserType = (state: ReduxState): userTypeTypes => {
	if (state.auth.admin) {
		return 'admin';
	}
	if (state.auth.tipoUsuario === 'profesor') {
		return 'profesor';
	}
	if (state.auth.tipoUsuario === 'estudiante') {
		return 'student';
	}
	if (state.auth.tipoUsuario === 'colegio') {
		return 'colegio';
	}
	if (state.auth.tipoUsuario === 'monitor') {
		return 'monitor';
	}
	return 'noUser';
};

export const selectCurrentUserNivel = (state: ReduxState) => {
	if (selectUserType(state) === 'student') {
		return state.auth.nivel;
	}
};

export const selectCurrentUserGroupKey = (state: ReduxState) => {
	return state.auth.groupKey;
};

export const selectCurrentUserColegio = (state: ReduxState) => {
	return state.auth.colegio;
};
